export function addUniqueLessonStudent(students, studentId) {
  if ((students || []).some(student => student.id === studentId)) {
    return students;
  }

  return [...(students || []), { id: studentId }];
}

export function findLessonRegisterStudentConflicts(students = []) {
  const studentsById = students.reduce((groupedStudents, student) => ({
    ...groupedStudents,
    [student.id]: [...(groupedStudents[student.id] || []), student],
  }), {});

  return Object.keys(studentsById)
    .map(studentId => ({
      studentId,
      entries: studentsById[studentId],
    }))
    .filter(group => (
      group.entries.length > 1 &&
      new Set(group.entries.map(entry => String(entry.isPresent))).size > 1
    ));
}

export function normalizeLessonRegisterStudents(students = []) {
  return students.reduce((normalizedStudents, student) => {
    const existingIndex = normalizedStudents.findIndex(currentStudent => (
      currentStudent.id === student.id &&
      currentStudent.isPresent === student.isPresent
    ));

    if (existingIndex === -1) {
      return [...normalizedStudents, student];
    }

    return normalizedStudents;
  }, []);
}
